import { CalendarPlanThemeActivities } from '@yandex-int/k-common';
import { getCalendarPlanThemeActivities } from '@yandex-int/k-common/client/api/defs/get-calendar-plan-theme-activities';
import { showNetworkError } from 'platform-components';
import { reportMessage } from 'platform-components/src/utils/raven-message';
import { all, call, put, takeEvery } from 'redux-saga/effects';

import { calendarPlanActions } from './actions';

export function* calendarPlanSagasWatcher() {
    yield all([takeEvery(calendarPlanActions.getThemeActivitiesRequest, getCalendarPlanThemeActivitiesSaga)]);
}

function* getCalendarPlanThemeActivitiesSaga(action: ReturnType<typeof calendarPlanActions.getThemeActivitiesRequest>) {
    const { themeIds } = action.payload;
    try {
        if (!themeIds.length) {
            yield put(calendarPlanActions.getThemeActivitiesSuccess({ themes: [] }));
            return;
        }

        const themes: CalendarPlanThemeActivities[] = yield call(getCalendarPlanThemeActivities, {
            theme_ids: themeIds,
        });
        yield put(calendarPlanActions.getThemeActivitiesSuccess({ themes }));
    } catch (error) {
        if (error.status === 404) {
            yield put(calendarPlanActions.getThemeActivitiesSuccess({ themes: [] }));
            return;
        }

        reportMessage('getCalendarPlanThemeActivitiesSaga error', error);
        yield put(showNetworkError(error));
    }
}
